export const BUSINESS_PARTNER_REGEX = /^\d+,[^,]+,[a-zA-Z]{2}$/;
export const BUSINESS_PARTNER_SEPARATOR = /[\n]/; // endline
export const BUSINESS_PARTNER_FIELD_SEPARATOR = /,/;
